class ReportFilter {
    constructor(filter = {}) {
        console.log(`ReportFilter ${JSON.stringify(filter, null, 4)}`)
        this.benchmarks = filter.benchmarks || new Map()
        this.campaigns = filter.campaigns || []
        this.years = filter.years || []
        this.fromDate = filter.fromDate || undefined
        this.toDate = filter.toDate || undefined
        this.states = filter.states || ['completed']
        this.langCode = filter.langCode
        this.clientId = filter.clientId
        this.surveyId = filter.surveyId
        this.includeTest = filter.includeTest
        this.filter = []
        this.includeIncomplete = filter.includeIncomplete
    }

    toggleBenchmark = (benchmark) => {
        if (!this.benchmarks.has(benchmark)) {
            this.benchmarks.set(benchmark, false)
        }
        console.log(`toggleBenchmark ${this.benchmarks.get(benchmark)}`)
        this.benchmarks.set(benchmark, !this.benchmarks.get(benchmark))

        // const index = this.benchmarks.indexOf(benchmark)
        // if (index > -1) {
        //     this.benchmarks.splice(index, 1)
        // } else {
        //     this.benchmarks.push(benchmark)
        // }
    }

    setDate(value, target = 'from') {
        if (target === 'from') {
            this.fromDate = value
            console.log(`setDate ${value} ${typeof value} ${parseInt(value, 10)}`)
        } else if (target === 'to') {
            this.toDate = value
        } else {
            console.log(`Invalid date target ${target} for value ${value}`)
        }
    }

    toggleYears(year) {
        // const index = this.years.indexOf(year)
        // if (index > 0) {
        //     this.years.splice(index, 1)
        // } else {
        //     this.years.push(year)
        // }
        this.years = [year]
    }

    toggleCampaigns(campaign) {
        // const index = this.campaigns.indexOf(campaign)
        // if (index > 0) {
        //     this.yeacampaignsrs.splice(index, 1)
        // } else {
        //     this.campaigns.push(campaign)
        // }
        this.campaigns = [campaign]
    }

    toggleStates(state) {
        if (state === 'test') {
            this.includeTest = !this.includeTest
        } else if (state === 'incomplete') {
            this.includeIncomplete = !this.includeIncomplete
        }
    }

    toJSON() {
        return {
            state: this.states,
            benchmarks: this.benchmarks,
            campaigns: this.campaigns,
            years: this.years,
            fromDate: this.fromDate,
            toDate: this.toDate,
            filter: this.filter,
        }
    }

    toQueryString() {
        return `langcode=${this.langCode}&surveyDataId=&surveyId=${this.surveyId}&filter=${this.filter}&startDate=${this.fromDate || ''}&endDate=${this.toDate || ''}&testdata=${this.includeTest}&includeIncompletes=${this.includeIncomplete}&campaignfilter=${this.campaigns[0] || ''}&comparefilter=${this.years[0].id || ''}&isPdfReport=false&clientID=${this.clientId}&includeothertext=1`
    }
}

export default ReportFilter
